import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${queryFilter.sort},${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/core/nacionalidades${queryUrl}`)
  },
  insertNewNacionality(data) {
    return axios.post('/core/nacionalidades', data)
  },
  editNacionality(data) {
    return axios.put(`/core/nacionalidades/${data.id}`, data)
  },
  deleteNacionality(id) {
    return axios.delete(`/core/nacionalidades/${id}`)
  },
}
